import { InputAdornment } from '@material-ui/core'
import { AttachMoney } from '@material-ui/icons'

const getFieldValue = (event) => event?.target?.value ?? event?.value?.label ?? event?.value ?? ''

export const SALDOS = (data, handleChange, edit, dataBefore, infoClient) => {
  return [
    {
      class: 'textfield',
      type: 'number',
      name: 'credito_compras',
      label: 'Crédito compras',
      value: data.credito_compras,
      sm: 6,
      xs: 12,
      disabled:
        infoClient.estado === 'INCOBRABLE'
          ? true
          : dataBefore.data.permissions.allowSaldo
            ? !edit
            : true,
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
      onChange: (e) => {
        handleChange('credito_compras', getFieldValue(e))
      },
    },
    {
      class: 'textfield',
      type: 'number',
      name: 'credito_valores',
      label: 'Crédito valores',
      value: data.credito_valores,
      disabled: dataBefore.data.permissions.allowEdit ? !edit : true,
      sm: 6,
      xs: 12,
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
      onChange: (e) => {
        handleChange('credito_valores', getFieldValue(e))
      },
    },
    {
      class: 'textfield',
      type: 'number',
      name: 'saldo',
      label: 'Saldo',
      value: data.saldo,
      sm: 6,
      xs: 12,
      disabled: true,
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
        style: {
          color:
            data.saldo === 0 || data.saldo === '0.00'
              ? 'inherit'
              : data.saldo < 0
                ? '#2e7d32'
                : '#d32f2f',
          fontWeight: data.saldo === 0 || data.saldo === '0.00' ? 'normal' : 'bold',
        },
      },
      onChange: (e) => {
        handleChange('saldo', getFieldValue(e))
      },
    },
    {
      class: 'textfield',
      type: 'number',
      sm: 6,
      xs: 12,
      name: 'limite_consumo',
      label: 'Límite de consumo',
      value: data.limite_consumo,
      disabled: true,
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
      onChange: (e) => handleChange('limite_consumo', getFieldValue(e)),
    },
    {
      class: 'textfield',
      type: 'number',
      sm: 6,
      xs: 12,
      name: 'dias_atraso',
      label: 'Días de atraso',
      value: data.dias_atraso,
      disabled: true,
      onChange: (e) => handleChange('dias_atraso', getFieldValue(e)),
    },
    {
      class: 'textfield',
      type: 'number',
      sm: 6,
      xs: 12,
      name: 'limite_valores',
      label: 'Límite de valores',
      value: data.limite_valores,
      disabled: true,
      onChange: (e) => handleChange('limite_valores', getFieldValue(e)),
    },
  ]
}
